import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import "./LeaveApply.css";
import { useDispatch, useSelector } from "react-redux";
import { getLeaveBalanceList, getLeaveListByYear, getLeaveSummary } from "../../Redux/Leave/Action";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import Select from "react-select";
import { FaInfoCircle } from "react-icons/fa";
import NewDataTable from "../DataTable/NewDataTable";


const LeaveReport = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const { leavebalancelist, leavelistbyyear, leavesummary } = useSelector((store) => store.leave);
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [clList, setClList] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [infoLeaveData, setInfoLeaveData] = useState(null);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear.toString(),
  });


  const columns = [
    {
      name: "SN",
      cell: (_, index) => index + 1,
      sortable: false,
      width: "80px",
      align: "center",
    },
    {
      name: "Employee",
      selector: (row) => row?.empName || "-",
      sortable: true,
      align: "center",
    },
    {
      name: "Total CL",
      selector: (row) => row?.clTotalCount ?? "-",
      sortable: true,
      align: "center",
    },
    {
      name: "CL Utilized",
      selector: (row) => row?.clApproveCount ?? "-",
      sortable: true,
      align: "center",
    },
    {
      name: "CL Applied",
      selector: (row) => row?.clAppliedCount ?? "-",
      sortable: true,
      align: "center",
    },
    {
      name: "CL Balance",
      selector: (row) => row?.leaveDays ?? "-",
      sortable: true,
      align: "center",
    },

    // {
    //   name: "Total COM",
    //   selector: (row) => row?.comCount ?? "-",
    //   sortable: true,
    //   align: "center",
    // },
    {
      name: "Total LOP",
      selector: (row) => row?.lopCount ?? "-",
      sortable: true,
      align: "center",
    },

  ];


  useEffect(() => {
    dispatch(empList(token, "All"));
    if (selectedYear) {
      dispatch(getLeaveSummary(token, selectedYear.value));
    }
  }, [dispatch, token, loginId, selectedYear]);

  useEffect(() => {
    if (leavebalancelist) {
      const list = leavebalancelist.filter((leave) => leave.leaveCode === "CL")
      setClList(list?.[0]);
    }

  }, [leavebalancelist])





  const options = [
    { value: 'all', label: 'All' },
    ...emplists.map((emp) => ({
      value: emp.loginId,
      label: `${emp?.firstName || ""} ${emp?.lastName || ""}`.trim(),
    })),
  ];


  // Generate last 10 years
  const yearOptions = Array.from({ length: 10 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });


  const handleChange = (option) => {
    setSelectedYear(option);
  };

  useEffect(() => {
    if (options.length > 0 && selectedEmployee === null) {
      setSelectedEmployee(options[0]);
    }
  }, [options, selectedEmployee]);

  useEffect(() => {
    dispatch(getLeaveBalanceList(token, selectedEmployee?.value, 'Apply'));
    dispatch(getLeaveListByYear(token, selectedEmployee?.value, selectedYear?.value));
  }, [selectedEmployee, selectedYear]);


  const handleEmpChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
  };


  const statusMap = {
    S: "Success",
    A: "Applied",
    R: "Reverted",
  };
  const statusColorMap = {
    S: "text-success",
    A: "text-primary",
    R: "text-danger",
  };

  const handleInfoClick = (leave) => {
    setInfoLeaveData(leave);
    setShowInfo(true);
  }

  const handleInfoClose = () => {
    setShowInfo(false);
    setInfoLeaveData(null);
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  return (
    <div>
      <Navbar> </Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">

          <div className="card3">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0  left-header"></h5>

                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center">
                    <b><label className="me-1 mb-0 custom-label">Year:</label></b>
                    <div style={{ width: '120px' }}>
                      <Select
                        options={yearOptions}
                        value={selectedYear}
                        onChange={handleChange}
                        placeholder="Select Year"
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center">
                    <b><label className="me-1 mb-0 custom-label">Employee:</label></b>
                    <div style={{ width: '300px' }}>
                      <Select
                        options={options}
                        value={selectedEmployee}
                        onChange={handleEmpChange}
                        placeholder="Select Employee"
                        isClearable
                      />
                    </div>
                  </div>
                </div>
              </div>
              {selectedEmployee?.value === "all" ? (
                <>

                  <NewDataTable
                    columns={columns}
                    data={leavesummary || []}
                    tableName="LEAVE REPORT"
                  />
                </>
              ) : (<div>
                <div className="container my-2">
                  <div className="d-flex justify-content-center align-items-center gap-5">
                    <div className="text-center">
                      <h6 className="mb-1">
                        Total Leave Entitlement (CL): {(clList?.leaveDays ?? 0) + (clList?.appliedDays ?? 0)}
                      </h6>
                    </div>

                    <div className="text-center">
                      <h6 className="mb-1">
                        Leave Utilized: {clList?.appliedDays ?? 0}
                      </h6>
                    </div>

                    <div className="text-center">
                      <h6 className="mb-1">
                        Leave Balance Remaining: {clList?.leaveDays ?? 0}
                      </h6>
                    </div>
                  </div>


                </div>
                <div className="row mt-1">
                  <div className="col-md-6 mb-3">
                    <div className="card shadow-sm h-100 rounded-4">
                      <div className="card-body text-center">
                        <h5 className="card-title" style={{
                          display: "inline-block",
                          backgroundColor: "lightcyan",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          textDecoration: "none"
                        }}>Applied CL</h5>
                        <table className="table table-bordered table-striped table-hover table-responsive">
                          <thead>
                            <tr>
                              <th className="thead-leave">SN</th>
                              <th className="thead-leave">Start</th>
                              <th className="thead-leave">End</th>
                              <th className="thead-leave">Days</th>
                              <th className="thead-leave">Status</th>
                              <th className="thead-leave">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leavelistbyyear && leavelistbyyear.filter((leave) => leave.leaveCode === "CL").length > 0 ? (
                              leavelistbyyear
                                .filter((leave) => leave.leaveCode === "CL")
                                .map((leave, index) => {
                                  return (
                                    <tr key={index} style={{ fontSize: "14px" }}>
                                      <td>{index + 1}</td>
                                      <td className="td-leave">{leave.startDate}</td>
                                      <td className="td-leave">{leave.endDate}</td>
                                      <td>{leave.noOfDays}</td>
                                      <td className={`${statusColorMap[leave.status]} fw-bold`}>{statusMap[leave.status] || leave.status}</td>
                                      <td>
                                        <Tooltip text="Info">
                                          <FaInfoCircle onClick={() => handleInfoClick(leave)} className="text-primary cursor-pointer" />
                                        </Tooltip>
                                      </td>
                                    </tr>
                                  );
                                })
                            ) : (
                              <tr>
                                <td colSpan="7">No leave data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-md-4 mb-3">
                    <div className="card shadow-sm h-100 rounded-4">
                      <div className="card-body text-center">
                        <h5 className="card-title" style={{
                          display: "inline-block",
                          backgroundColor: "lightcyan",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          textDecoration: "none"
                        }}>Applied COM</h5>
                        <table className="table table-bordered table-striped table-hover table-responsive">
                          <thead>
                            <tr>
                              <th className="thead-leave">SN</th>
                              <th className="thead-leave">Start</th>
                              <th className="thead-leave">End</th>
                              <th className="thead-leave">Days</th>
                              <th className="thead-leave">Status</th>
                              <th className="thead-leave">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leavelistbyyear && leavelistbyyear.filter((leave) => leave.leaveCode === "COM").length > 0 ? (
                              leavelistbyyear
                                .filter((leave) => leave.leaveCode === "COM")
                                .map((leave, index) => {
                                  const [day, month, year] = leave.startDate.split("-");
                                  const parsedStartDate = new Date(
                                    `${year}-${month}-${day}`
                                  );

                                  return (
                                    <tr key={index} style={{ fontSize: "13px" }}>
                                      <td>{index + 1}</td>
                                      <td className="td-leave">{leave.startDate}</td>
                                      <td className="td-leave">{leave.endDate}</td>
                                      <td>{leave.noOfDays}</td>
                                      <td className={`${statusColorMap[leave.status]} fw-bold`}>{statusMap[leave.status] || leave.status}</td>
                                      <td>
                                        <Tooltip text="Info">
                                          <FaInfoCircle onClick={() => handleInfoClick(leave)} className="text-primary cursor-pointer" />
                                        </Tooltip>
                                      </td>
                                    </tr>
                                  );
                                })
                            ) : (
                              <tr>
                                <td colSpan="7">No leave data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div> */}

                  <div className="col-md-6 mb-3">
                    <div className="card shadow-sm h-100 rounded-4">
                      <div className="card-body text-center">
                        <h5 className="card-title" style={{
                          display: "inline-block",
                          backgroundColor: "lightcyan",
                          padding: "4px 10px",
                          borderRadius: "6px",
                          textDecoration: "none"
                        }}>Applied LOP</h5>
                        <table className="table table-bordered table-striped table-hover table-responsive">
                          <thead>
                            <tr>
                              <th className="thead-leave">SN</th>
                              <th className="thead-leave">Start</th>
                              <th className="thead-leave">End</th>
                              <th className="thead-leave">Days</th>
                              <th className="thead-leave">Status</th>
                              <th className="thead-leave">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leavelistbyyear && leavelistbyyear.filter((leave) => leave.leaveCode === "LOP").length > 0 ? (
                              leavelistbyyear
                                .filter((leave) => leave.leaveCode === "LOP")
                                .map((leave, index) => {
                                  const [day, month, year] = leave.startDate.split("-");
                                  const parsedStartDate = new Date(
                                    `${year}-${month}-${day}`
                                  );

                                  return (
                                    <tr key={index} style={{ fontSize: "14px" }}>
                                      <td>{index + 1}</td>
                                      <td className="td-leave">{leave.startDate}</td>
                                      <td className="td-leave">{leave.endDate}</td>
                                      <td>{leave.noOfDays}</td>
                                      <td className={`${statusColorMap[leave.status]} fw-bold`}>{statusMap[leave.status] || leave.status}</td>
                                      <td>
                                        <Tooltip text="Info">
                                          <FaInfoCircle onClick={() => handleInfoClick(leave)} className="text-primary cursor-pointer" />
                                        </Tooltip>
                                      </td>
                                    </tr>
                                  );
                                })
                            ) : (
                              <tr>
                                <td colSpan="7">No leave data available</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
                {showInfo && (
                  <div
                    className="modal fade show leave-modal"
                    tabIndex="-1"
                    style={{
                      display: "block",
                      backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                  >
                    <div className="modal-dialog modal-md modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">LEAVE DESCRIPTION</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={handleInfoClose}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <p>
                            <strong>Leave Period:</strong> {infoLeaveData.startDate} to {infoLeaveData.endDate}
                          </p>
                          <p>
                            <strong>Remark:</strong> {infoLeaveData.remark || "N/A"}
                          </p>
                        </div>

                      </div>
                    </div>
                  </div>
                )}
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default LeaveReport;
